export default class BackToTop {
  constructor() {
    this.backToTopBlock = document.querySelector('.back-to-top-block');

    if (this.backToTopBlock) {
      this.backToTopButton = this.backToTopBlock.querySelector(
        '.back-to-top--button',
      );
    }
  }

  static onBackToTopClicked() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  setVisualState() {
    if (this.backToTopBlock) {
      const heightToShowBackToTopBlock = 2000;

      if (document.documentElement.scrollHeight < heightToShowBackToTopBlock) {
        this.backToTopBlock.classList.add('hidden');
      } else {
        this.backToTopBlock.classList.remove('hidden');
      }
    }
  }

  setListeners() {
    if (this.backToTopBlock) {
      this.backToTopButton.addEventListener('click', () =>
        BackToTop.onBackToTopClicked(),
      );
    }
  }
}

(() => {
  const backToTop = new BackToTop();
  backToTop.setVisualState();
  backToTop.setListeners();
})(Drupal);
